import { setExperiments } from "#webapp/src/state/actions/auth.actions";
import {
  setActiveView,
  setActiveViewCalendarProfile,
  setActiveViewEvent,
  setContentScrollTop,
  setMenuDrawerOpen,
  setOpenShareLinkModal,
  setOpenShareWithCoworkersModal,
  setShouldSyncActiveOrg,
} from "#webapp/src/state/actions/chrome-extension.actions";
import { refetchFeed } from "#webapp/src/state/actions/chrome-feed.actions";
import { setFeatureGridStates } from "#webapp/src/state/actions/feature-grid.actions";
import { setSelectedTabView } from "#webapp/src/state/actions/nav-tabs.actions";
import {
  setFastCrawlFinishedRefetchComplete,
  setFastCrawlFlowState,
  setFastCrawlTeammatesIdentifiedRefetchComplete,
  setFastCrawlUserCrawledRefetchComplete,
  setOnboardingFlowState,
} from "#webapp/src/state/actions/onboarding.actions";
import {
  setOrgBillingGroupIds,
  setPricingDialogOpen,
  updateShouldRefetch,
} from "#webapp/src/state/actions/payments.actions";
import { snackBarOpen } from "#webapp/src/state/actions/snack-bar.actions";
import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import withStyles from "@material-ui/core/styles/withStyles";
import React from "react";
import { connect } from "react-redux";
import { createRefetchContainer } from "react-relay";
import ChromeWrapperComponent from "./ChromeWrapper.component";
import { chromeWrapperFragments, chromeWrapperQuery } from "./ChromeWrapper.gql";
import { styles } from "./ChromeWrapper.styles";
import { IContainer } from "./ChromeWrapperTypes";

/////////////////
// With Styles //
/////////////////

const ChromeWrapperWithStyles = withStyles(styles)(ChromeWrapperComponent);

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    calendarMismatch: state.webExtension.calendarMismatch,
    calendarUrl: state.webExtension.calendarUrl,
    calendarProfile: state.webExtension.activeViewCalendarProfile,
    createEvent: state.webExtension.createEvent,
    editEvent: state.webExtension.editEvent,
    preEventFlexibility: state.webExtension.preEventFlexibility,
    preEventKey: state.webExtension.preEventKey,
    preEventCalendarId: state.webExtension.preEventCalendarId,
    isChromeExtension: state.webExtension.isWebExtension,
    mode: state.webExtension.mode,
    menuDrawerOpen: state.webExtension.menuDrawerOpen,
    activeView: state.webExtension.activeView,
    activeViewEvent: state.webExtension.activeViewEvent,
    activeViewThreadInfo: state.webExtension.activeViewThreadInfo,
    chromeExtensionIdle: state.webExtension.webExtensionIdle,
    chromeExtensionOpen: state.webExtension.webExtensionOpen,
    chromeExtensionInstalled: state.webExtension.webExtensionInstalled,
    chromeExtensionVersion: state.webExtension.webExtensionVersion,
    chromeExtensionShadowCalendarActive: state.webExtension.webExtensionShadowCalendarActive,
    chromeSchedulerEmails: state.webExtension.schedulerEmails,
    setUserFlagMillis: state.webExtension.setUserFlagMillis,
    userFlag: state.webExtension.userFlag,
    smartHoldUpdatedMillis: state.webExtension.smartHoldUpdatedMillis,
    unsubscribedCalendarId: state.webExtension.unsubscribedCalendarId,
    unsubscribedCalendarIdMillis: state.webExtension.unsubscribedCalendarIdMillis,
    windowUserEmail: state.webExtension.windowUserEmail,
    selectedTabView: state.navTabs.selectedTabView,
    selectedMoment: state.dayView.selectedMoment,
    pricingDialogInfo: state.webExtension.pricingDialogInfo,
    shouldFetchSuggestedTimes: state.webExtension.shouldFetchSuggestedTimes,
    editEventInfo: state.webExtension.editEventInfo,
    featureGrid: state.featureGrid,
    onboardingFlowStateCurrentStatus: state.onboarding.onboardingFlowStateCurrentStatus,
    onboardingFinished: state.onboarding.onboardingFinished,
    onboardingLoaded: state.onboarding.onboardingLoaded,

    fastCrawlFlowStateCurrentStatus: state.onboarding.fastCrawlFlowStateCurrentStatus,
    fastCrawlFlowStateErrorMessage: state.onboarding.fastCrawlFlowStateErrorMessage,
    fastCrawlRunning: state.onboarding.fastCrawlRunning,
    fastCrawlFatalState: state.onboarding.fastCrawlFatalState,
    fastCrawlUserCrawledComplete: state.onboarding.fastCrawlUserCrawledComplete,
    fastCrawlUserCrawledRefetchComplete: state.onboarding.fastCrawlUserCrawledRefetchComplete,
    fastCrawlTeammatesIdentifiedComplete: state.onboarding.fastCrawlTeammatesIdentifiedComplete,
    fastCrawlTeammatesIdentifiedRefetchComplete:
      state.onboarding.fastCrawlTeammatesIdentifiedRefetchComplete,
    fastCrawlFinished: state.onboarding.fastCrawlFinished,
    fastCrawlFinishedRefetchComplete: state.onboarding.fastCrawlFinishedRefetchComplete,

    shouldSyncActiveOrg: state.webExtension.shouldSyncActiveOrg,

    pricingDialogState: state.payments.pricingDialogState,
    shouldRefetchDueToPlanUpgrade: state.payments.shouldRefetchDueToPlanUpgrade,

    sendInvites: state.webExtension.sendInvites,
    openShareWithCoworkersModal: state.webExtension.openShareWithCoworkersModal,
  };
}

const ChromeWrapperWithRedux = connect(mapStateToProps, {
  refetchFeed,
  snackBarOpen,
  setActiveView,
  setActiveViewCalendarProfile,
  setActiveViewEvent,
  setSelectedTabView,
  setExperiments,
  setOrgBillingGroupIds,
  setMenuDrawerOpen,
  setOnboardingFlowState,
  setFastCrawlFlowState,
  setFastCrawlUserCrawledRefetchComplete,
  setFastCrawlFinishedRefetchComplete,
  setFastCrawlTeammatesIdentifiedRefetchComplete,
  setContentScrollTop,
  setShouldSyncActiveOrg,
  setPricingDialogOpen,
  updateShouldRefetch,
  setOpenShareLinkModal,
  setOpenShareWithCoworkersModal,
  setFeatureGridStates,
})(ChromeWrapperWithStyles);

//////////////////
// RELAY
//////////////////
export const ChromeWrapperModern = createRefetchContainer(
  ChromeWrapperWithRedux,
  chromeWrapperFragments,
  chromeWrapperQuery,
);

export const ChromeWrapper = (props: IContainer) => {
  // hack to remove body scrolling while we still have to support marketing pages
  // document.body.style.overflow = 'hidden';
  return <ChromeWrapperModern {...props} useModern={true} />;
};
